import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import {CrawlResult} from "@/services/models/CrawlResult";
import {CrawlRequest} from "@/services/models/crawlRequest";
import {ScraperPlan} from "@/services/models/scraperPlan";
import {baseQueryWithReAuth} from "@/store/features/baseRtkQuery";
import {API_CONFIG} from "@/constants/apiConstants";

export const scraperApi = createApi({
    reducerPath: 'scraperApi',
    baseQuery: baseQueryWithReAuth,
    endpoints: (builder) => ({
        getAllPlans: builder.query<ScraperPlan[], void>({
            query: () => ({
                url: '/DynamicKnowledge/scheduledPlans',
                method: 'GET',
            }),
        }),
        getPlan: builder.query<ScraperPlan, string>({
            query: (id) => ({
                url: `/DynamicKnowledge/scheduledPlans/${id}`,
                method: 'GET',
            }),
        }),
        createPlan: builder.mutation<ScraperPlan, any>({
            query: (planData) => ({
                url: `/DynamicKnowledge`,
                method: 'POST',
                body: planData,
            }),
        }),
        updatePlan: builder.mutation<ScraperPlan, any>({
            query: (planData) => ({
                url: `/DynamicKnowledge/${planData.id}`,
                method: 'PUT',
                body: planData,
            }),
        }),
        crawlWebsite: builder.mutation<CrawlResult, CrawlRequest>({
            query: (crawlParams) => ({
                url: '/crawl',
                method: 'POST',
                body: crawlParams,
            }),
        }),
    }),
});

export const {
    useGetPlanQuery,
    useCreatePlanMutation,
    useUpdatePlanMutation,
} = scraperApi;